import { Component, OnInit } from '@angular/core';
import { Toast, ToastType } from '../../shared.model';
import { DialogService } from '../../services/dialog.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.css',
    standalone: false
})
export class ToastComponent implements OnInit {
  alertType?: ToastType;
  message?: string;
  title?: string;
  toastType = ToastType;
  show = false;

  constructor(private dialogService: DialogService, private toastr: ToastrService) { }
  ngOnInit(): void {
    this.dialogService.toast$.subscribe((res) => {
      if (res.type == 'show') {
        const data = res.data as Toast;
        this.alertType = data.toastType;
        this.title = this.alertType == ToastType.Success ? 'Success' : 'Error';
        this.message = data.message;
        this.show = true;
      }
    });
  }



  // onDropdownChange(event: any) {
  //   const dropdown = document.getElementById('myDropdown');
  //   const rect = dropdown?.getBoundingClientRect();

  //   if (rect) {
  //     const top = rect.top + window.scrollY;
  //     const left = rect.left + window.scrollX;

  //     const toastRef = this.toastr.success('Value selected!', '', {
  //       disableTimeOut: false,
  //       tapToDismiss: true
  //     });

  //     setTimeout(() => {
  //       const toastEl = document.querySelector('.custom-toast') as HTMLElement;
  //       if (toastEl) {
  //         toastEl.style.top = `${top}px`;
  //         toastEl.style.left = `${left}px`;
  //       }
  //     }, 0);
  //   }}

  }